import { render, staticRenderFns } from "./DynamicNotice.vue?vue&type=template&id=ccede17a"
import script from "./DynamicNotice.vue?vue&type=script&lang=js"
export * from "./DynamicNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ccede17a')) {
      api.createRecord('ccede17a', component.options)
    } else {
      api.reload('ccede17a', component.options)
    }
    module.hot.accept("./DynamicNotice.vue?vue&type=template&id=ccede17a", function () {
      api.rerender('ccede17a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tools/DynamicNotice.vue"
export default component.exports